const ONE_SIGNAL_NO_SUBSCRIPTION_EVENT_PATTERNS = [
  'Blur error',
  'Focus error',
  'Visibility change error',
];

function getConsoleArgText(arg: unknown): string {
  if (arg instanceof Error) {
    return `${arg.message}\n${arg.stack ?? ''}`;
  }

  if (typeof arg === 'string') {
    return arg;
  }

  return '';
}

export function isOneSignalNoSubscriptionConsoleNoise(args: unknown[]): boolean {
  const text = args.map(getConsoleArgText).join('\n');

  return ONE_SIGNAL_NO_SUBSCRIPTION_EVENT_PATTERNS.some(pattern => text.includes(pattern))
    && text.includes('No subscription');
}
